// React
import { createContext } from "react"

export const PrintItemContext = createContext<{
  selectedItem: string[]
  items: any[]
}>({
  selectedItem: [],
  items: []
})